var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.898,
    height: 17.666,
    viewBox: "0 0 15.898 17.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "User",
    d: "M12.5,4.667a3.633,3.633,0,1,0,2.569,1.064A3.633,3.633,0,0,0,12.5,4.667ZM7.3,8.3a5.2,5.2,0,1,1,1.523,3.677A5.2,5.2,0,0,1,7.3,8.3Zm1.667,8.733a2.75,2.75,0,0,0-2.75,2.75.783.783,0,1,1-1.567,0,4.317,4.317,0,0,1,4.317-4.317h7.067a4.317,4.317,0,0,1,4.317,4.317.783.783,0,0,1-1.567,0,2.75,2.75,0,0,0-2.75-2.75Z",
    transform: "translate(-4.551 -3)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.ad72af9eabb0294284c14cbe5e4ef3ba.svg";
export { ForwardRef as ReactComponent };